/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconAssessment/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconAssessment({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconAssessment",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconAssessment.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-yvyB1': alignSelf,'--mt-2-yvyB1': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-yvyB1': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-yvyB1': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-yvyB1': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-yvyB1': opacity,'--w-10-yvyB1': typeof width === 'number' ? `${width}px` : width,'--h-11-yvyB1': typeof height === 'number' ? `${height}px` : height,'--a-7-yvyB1': isAnimated ? animation : "none",'--sd-8-yvyB1': isAnimated ? strokeDashoffset : 0,'--sd-9-yvyB1': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconAssessment.SvgPath"
  data-view-path={viewPath}
 d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7v-7zm4-3h2v10h-2V7zm4 6h2v4h-2v-4z"
 style={{'--f-12-yvyB1': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}